import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eHealthProblemActionTypeIds, IHealthProblemActionTypes } from "../../action-types/y-te/IHealthProblemActionTypes";
import { IHealthProblemPageStateModel } from "../../page-state-model/y-te/IHealthProblemPageState";

const initialState: IHealthProblemPageStateModel = {
	status: ePageBaseStatus.is_not_initialization,
	healthproblems: [],
	healthproblem_editing: undefined,
	healthproblem_selected_ids: [],
	is_show_detail_modal: false,
	is_show_delete_confirm: false,
	is_loading_detail: false,
	is_show_dangky_modal: false,
	dangky_status: ePageBaseStatus.is_not_initialization,
	healthproblems_dangky: []
}

export const healthProblemReducer = (state: IHealthProblemPageStateModel = initialState, action: IHealthProblemActionTypes): IHealthProblemPageStateModel => {
	switch (action.type) {
		case eHealthProblemActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading
			}
		case eHealthProblemActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				healthproblems: action.payload
			}
		case eHealthProblemActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				healthproblems: []
			}
		case eHealthProblemActionTypeIds.LOAD_DETAIL_START:
			return {
				...state,
				is_loading_detail: true
			}
		case eHealthProblemActionTypeIds.LOAD_DETAIL_SUCCESS:
			return {
				...state,
				is_loading_detail: false,
				healthproblem_editing: action.payload
			}
		case eHealthProblemActionTypeIds.LOAD_DETAIL_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				is_loading_detail: false
			}
		case eHealthProblemActionTypeIds.SHOW_DETAIL:
			return {
				...state,
				is_show_detail_modal: true,
				healthproblem_editing: action.payload
			}
		case eHealthProblemActionTypeIds.CLOSE_DETAIL:
			return {
				...state,
				is_show_detail_modal: false,
				healthproblem_editing: undefined
			}
		case eHealthProblemActionTypeIds.CHANGE_SELECTED_IDS:
			return {
				...state,
				healthproblem_selected_ids: action.payload
			}
		case eHealthProblemActionTypeIds.SHOW_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: true
			}
		case eHealthProblemActionTypeIds.CLOSE_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: false
			}
		case eHealthProblemActionTypeIds.SAVE_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving
			}
		case eHealthProblemActionTypeIds.SAVE_SUCCESS:
			NotifyHelper.Success(action.payload ? "Cập nhật thành công" : "Thêm thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_detail_modal: false,
				healthproblem_editing: undefined
			}
		case eHealthProblemActionTypeIds.SAVE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed
			}
		case eHealthProblemActionTypeIds.DELETE_START:
			return {
				...state,
				status: ePageBaseStatus.is_deleting
			}
		case eHealthProblemActionTypeIds.DELETE_SUCCESS:
			NotifyHelper.Success("Xoá dữ liệu thành công.")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_delete_confirm: false,
				healthproblem_editing: undefined,
				healthproblem_selected_ids: []
			}
		case eHealthProblemActionTypeIds.DELETE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_delete_confirm: false
			}
		case eHealthProblemActionTypeIds.SHOW_DANGKY_MODAL:
			return {
				...state,
				is_show_dangky_modal: true,
				dangky_status: ePageBaseStatus.is_not_initialization,
				healthproblems_dangky: []
			}
		case eHealthProblemActionTypeIds.CLOSE_DANGKY_MODAL:
			return {
				...state,
				is_show_dangky_modal: false,
				dangky_status: ePageBaseStatus.is_not_initialization,
				healthproblems_dangky: []
			}
		case eHealthProblemActionTypeIds.LOAD_DANGKY_START:
			return {
				...state,
				dangky_status: ePageBaseStatus.is_loading
			}
		case eHealthProblemActionTypeIds.LOAD_DANGKY_SUCCESS:
			return {
				...state,
				dangky_status: ePageBaseStatus.is_completed,
				healthproblems_dangky: action.payload
			}
		case eHealthProblemActionTypeIds.LOAD_DANGKY_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				dangky_status: ePageBaseStatus.is_completed,
				healthproblems_dangky: []
			}
		case eHealthProblemActionTypeIds.CHANGE_DANGKY_DATAS:
			return {
				...state,
				healthproblems_dangky: action.payload
			}
		case eHealthProblemActionTypeIds.SAVE_DANGKY_START:
			return {
				...state,
				dangky_status: ePageBaseStatus.is_saving
			}
		case eHealthProblemActionTypeIds.SAVE_DANGKY_SUCCESS:
			NotifyHelper.Success("Cập nhật thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				dangky_status: ePageBaseStatus.is_completed,
				is_show_dangky_modal: false,
				healthproblems_dangky: []
			}
		case eHealthProblemActionTypeIds.SAVE_DANGKY_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				dangky_status: ePageBaseStatus.is_completed
			}
		default:
			return state;
	}
}
